import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  createHeadline,
  updateHeadline,
  deleteHeadline,
  softDeleteHeadline,
  searchFullTextHeadlines,
} from "./api";

export interface HeadlineCreateInput {
  subject: string;
  content?: string;
  reaction_details?: string;
  analysis_details?: string;
  tag_id_list?: number[];
  source?: string;
  published_at?: string;
}

export interface HeadlineUpdateInput extends Partial<HeadlineCreateInput> {
  id: number;
}

export const useHeadlinesCRUD = () => {
  const queryClient = useQueryClient();

  // Create headline
  const createMutation = useMutation({
    mutationFn: createHeadline,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["headlines"] });
      queryClient.invalidateQueries({ queryKey: ["headlines-count"] });
    },
  });

  // Update headline
  const updateMutation = useMutation({
    mutationFn: updateHeadline,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ["headlines"] });
      queryClient.invalidateQueries({ queryKey: ["headline", variables.id] });
    },
  });

  // Delete headline
  const deleteMutation = useMutation({
    mutationFn: deleteHeadline,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["headlines"] });
      queryClient.invalidateQueries({ queryKey: ["headlines-count"] });
    },
  });

  // Soft delete headline
  const softDeleteMutation = useMutation({
    mutationFn: softDeleteHeadline,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["headlines"] });
      queryClient.invalidateQueries({ queryKey: ["headlines-count"] });
    },
  });

  // Search full text headlines
  const searchMutation = useMutation({
    mutationFn: searchFullTextHeadlines,
  });

  return {
    createMutation,
    updateMutation,
    deleteMutation,
    softDeleteMutation,
    searchMutation,
  };
};
